import { useCallback, useEffect, useState } from "react";

const useUnmountEffect = (unmountFunction: () => Promise<void> | void) => {
  const [isUnmount, setIsUnmount] = useState(false);

  const handleUnmountFunction = useCallback(async () => {
    await unmountFunction();
  }, [unmountFunction]);

  useEffect(() => {
    return () => {
      if (!isUnmount) {
        handleUnmountFunction();
        setIsUnmount(true);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnmount]);
};

export default useUnmountEffect;
